import { CSSProperties } from 'react';

type GetInitialStyles = (position?: CSSProperties['position']) => CSSProperties;

const getInitialStyles: GetInitialStyles = (position = 'absolute') => ({
    position,
    opacity: 0,
    pointerEvents: 'none'
});

export default getInitialStyles;
